// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"7299c3f7","24":"0e20f6e1","66":"2d8770fd","168":"b69a53fa","199":"d3e68a40","390":"7e2379da","963":"f7fdef67"}[chunkId] + ".chunk.js";
};